import styles from './add-products-dialog.module.scss';
import { useContext, useEffect } from 'react';
import { useImmer } from 'use-immer';
import { CheckboxLabel, Dialog, DialogActions, DialogContent, DialogTitle, GrayOutlinedButton, PrimaryButton, SnackBarContext } from '@frontend-workspace/react-shared-lib';
import { IProduct } from '../../_models/product';
import { useTranslation } from 'react-i18next';
import { useMakeRequestHook } from '../../requestUtils';

/* eslint-disable-next-line */
export interface AddProductsDialogProps {
  open: boolean,
  onClose: () => void,
  groupId: string
}

export function AddProductsDialog(props: AddProductsDialogProps) {
  const { t } = useTranslation();
  const makeRequest = useMakeRequestHook();
  const [products, updateProducts] = useImmer<IProduct[]>([]);
  const { setSnackbarMessage } = useContext(SnackBarContext);

  useEffect(() => {
    makeRequest(`relationProductGroups/${props.groupId}/products`).then(updateProducts);
  }, [props.groupId]);

  const handleUpdateProducts = () => {
    const selectedProductIds = products.filter(p => p.isInGroup).map(p => p.id);
    makeRequest(`relationProductgroups/${props.groupId}/action/addProductsToGroup`, 'PUT', { productIds: selectedProductIds })
      .then(result => {
        setSnackbarMessage({ content: t("addProducts.productAddedToGroup"), type: "success" });
        props.onClose();
      }).catch(() => setSnackbarMessage({ content: t("addProducts.couldNotAddProductToGroup"), type: "error" }));
  };

  return (
    <Dialog
      open={props.open}
      onClose={() => props.onClose()}
      maxWidth="md">
      <DialogTitle className='mb-4'>
        {t("standard.addProduct")}
      </DialogTitle>
      <DialogContent>
        {products.map(rp => {
          const onChange = (event: any, checked: boolean) => updateProducts(draft => {
            const product = draft.find(p => p.id === rp.id);
            if (product) product.isInGroup = checked
          });
          return (
            <CheckboxLabel
              key={rp.id}
              label={rp.name}
              checked={rp.isInGroup}
              onChange={onChange}
            />
          );
        })}
      </DialogContent>
      <DialogActions>
        <PrimaryButton
          variant="contained"
          size='large'
          onClick={handleUpdateProducts}
          className='minButtonWidth'>
          OK
        </PrimaryButton>
        <GrayOutlinedButton
          variant="outlined"
          size='large'
          onClick={props.onClose}
          className='minButtonWidth'>
          {t("standard.cancel")}
        </GrayOutlinedButton>
      </DialogActions>
    </Dialog>
  );
}

export default AddProductsDialog;